import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {setPageTitle} from "../../../modules/application/pages";

import buttonConfig from "./button-config.js";
import functionalSkillViewButtonConfig from "./button-config-functional-skill-view";

import OnlineRoomList from "../online-room-list/online-room-list.js";

//import PlayScreenCard from "./play-screen-card.js";
import PlayScreenCard from "./new-play-screen-card.js";

import NewsFeed from "./news-feed/news-feed.js";

import WelcomePopup from "../welcome-popup/welcome-popup.js";

import SaintPatricksDayEasterEgg from "./easter-eggs/saint_patricks_day/saint-patricks-day-easter-egg.js";

//import ValentinesEasterEgg from "./easter-eggs/valentines/valentines-easter-egg.js";

// import HanukkahEasterEgg from "./easter-eggs/hanukkah/hanukkah-easter-egg.js";
// import ChristmasEasterEgg from "./easter-eggs/christmas/christmas-easter-egg.js";


import TournamentDialog from "../tournaments/tournament-dialog.js";
import TournamentBanner from "../tournaments/tournament-banner.js";
import "./play-screen.css";
import {getActiveTournament} from "../../../modules/tournament.js";
import SplitIOTreatment from "../../splitio/splitioTreatment";
import FunctionalSkillsSwimlane from "../functional-skills-swimlane/functional-skills-swimlane";
import FunctionalSkillsLoad from "../functional-skills-swimlane/functional-skills-load";


const FUNCTIONAL_SKILL_FEATURE_NAME = "DC-640-functional-skills-swiming-lane";

class PlayScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canClickTurkey: true,
            showTurkey: false,
            turkeyRight: "220px",
            shakeTurkey: false
        };

        this.state = {
            canClickTree: true,
            showingSanta: false,
            canClickTurkey: true,
            showTurkey: false,
            turkeyRight: "220px",
            shakeTurkey: false,
            tournament_data: false,
            show_tournament_dialog: false,
            online_room_list: []
        };

        this.props.dispatch(setPageTitle(""));

        //setTimeout(this.setShakeTurkey.bind(this), 10000);
    }

    async componentDidMount() {
        let {token} = this.props;
        let currentTournamentResponse = await getActiveTournament(token);

        if (currentTournamentResponse.data.success) {
            let tournamentData = currentTournamentResponse.data.tournament;
            let active = currentTournamentResponse.data.active;

            tournamentData.active = active;
            this.setState({
                tournament_data: tournamentData
            });
        }
    }

    // setShakeTurkey(newShouldShake) {
    //     let {showTurkey} = this.state;
    //     if (typeof shouldShake === "undefined") {
    //         let {shakeTurkey} = this.state;
    //         newShouldShake = !shakeTurkey;
    //     }

    //     if (showTurkey) {
    //         newShouldShake = false;
    //     }


    //     if (newShouldShake) {
    //         setTimeout(this.setShakeTurkey.bind(this), 1000);
    //     }
    //     else {
    //         setTimeout(this.setShakeTurkey.bind(this), 10000);
    //     }

    //     this.setState({shakeTurkey: newShouldShake});
    // }

    // newTurkeyPosition() {
    //     let newTurkeyRight = Math.floor((Math.random() * 400) + 220);

    //     newTurkeyRight = newTurkeyRight + "px";
    //     this.setState({turkeyRight: newTurkeyRight});
    // }

    // turkeySoundEnd () {
    //     if (this.state.canClickTurkey) {
    //         return;
    //     }
     
    //     this.setState({canClickTurkey: true, showTurkey: false});

    //     setTimeout(this.newTurkeyPosition.bind(this), 500);
    // }

    // playTurkeySound () {
    //     if (!this.state.canClickTurkey) {
    //         return;
    //     }
        
    //     this.setState({canClickTurkey: false, showTurkey: true, shakeTurkey: false});

    //     var soundArray = ["gobble_1.wav", "gobble_2.wav", "gobble_3.wav"];

    //     var randomGobbleIndex = Math.floor(Math.random() * soundArray.length); 


    //     if (randomGobbleIndex > soundArray.length - 1) {
    //         randomGobbleIndex = soundArray.length - 1;
    //     }
    //     let filename = soundArray[randomGobbleIndex];
    //     let soundURL = require(`../../../static/assets/thanksgiving/${filename}`);
    //     let audio = new Audio();
    //     audio.src = soundURL;
    //     audio.onended = this.turkeySoundEnd.bind(this);
    //     audio.play();
    // }   


    showTournamentDialog() {
        this.setState({show_tournament_dialog: true});
    }

    hideTournamentDialog() {
        this.setState({show_tournament_dialog: false});
    }

    updateRoomList(roomList) {
        this.setState({online_room_list: roomList});
    }

    render () {
        const {token, currentUser} = this.props;
        const {/*showTurkey, turkeyRight, shakeTurkey,*/tournament_data, show_tournament_dialog, online_room_list} = this.state;

        // let turkeyClass = "thanksgiving_turkey";

        // let turkeyStyle = {
        //     right: turkeyRight
        // }

        // if (showTurkey) {
        //     turkeyClass += " show_turkey";
        // }

        // if (shakeTurkey) {
        //     turkeyClass += " shake"
        // }

        // let turkeyImage = "gobble.png";

        let limitedUser = currentUser.limited;
        return (
            <div className='play_screen'>
                {!currentUser.isSuperRole && <div id='play_screen_top_question'>How would you like to RESTORE-skills today?</div>}
                {tournament_data && <TournamentDialog tournament_data={tournament_data} show={show_tournament_dialog} hide_func={this.hideTournamentDialog.bind(this)} room_list={online_room_list} token={token}/>}
                {tournament_data && <TournamentBanner tournament_data={tournament_data} show_func={this.showTournamentDialog.bind(this)}/>}
                
                <SplitIOTreatment featureName={FUNCTIONAL_SKILL_FEATURE_NAME} treatmentValue="off"  trafficType="business-group">
                        {(treatment)=>{
                                if(treatment==="off"){
                                    return <OnlineRoomList />
                                }else if(treatment==="on")
                                {
                                    return <FunctionalSkillsSwimlane />
                                }else{
                                    return <FunctionalSkillsLoad />;
                                }
                            }
                        }
                </SplitIOTreatment>
                <SplitIOTreatment featureName="welcome_popup" treatmentValue="on">
                    {(treatment)=>{
                            if(treatment === "on"){
                                return <WelcomePopup />
                            }
                            else{
                                return null;
                            }
                        }
                    }
                </SplitIOTreatment>
                <div className='play_screen_card_container'>
                    <div className='play_screen_title'>On Demand</div>
                    <SplitIOTreatment featureName={FUNCTIONAL_SKILL_FEATURE_NAME} treatmentValue="off"  trafficType="business-group">
                        {(treatment)=>{
                                let relevantConfig;
                                if(treatment==="off"){
                                    relevantConfig = buttonConfig;
                                }else{
                                    relevantConfig = functionalSkillViewButtonConfig;
                                }

                                return relevantConfig.map((cardData) => {
                                    let locked = false;
                                    if (limitedUser && !cardData.limited) {
                                        locked = true;
                                        
                                    }
                                    
                                    return <PlayScreenCard key={cardData.title} card_data={cardData} token={token} locked={locked}></PlayScreenCard> 
                                })
                            }
                        }
                    </SplitIOTreatment>
                </div>

                <NewsFeed token={token}/>
                {/* <img title='Click Me... if you DARE!' alt='halloween_pumpkin' className={pumpkinClass} onClick={this.playHalloweenSound.bind(this)} src={require(`../../../static/assets/${pumpkinImageFilename}`)}></img> */}
                {/* <img title='Click Me...' style={turkeyStyle} alt='thanksgiving_turkey' className={turkeyClass} onClick={this.playTurkeySound.bind(this)} src={require(`../../../static/assets/thanksgiving/${turkeyImage}`)}></img> */}
                {/* <ChristmasEasterEgg />
                <HanukkahEasterEgg /> */}
                {/* <ValentinesEasterEgg /> */}
                <SplitIOTreatment featureName="st_patricks_day" treatmentValue="on">
                    {(treatment)=>{
                            if(treatment === "on"){
                                return(<SaintPatricksDayEasterEgg />)
                            }
                            return null;
                        }
                    }
                    
                </SplitIOTreatment>
            </div>
        )
    }
}



const withState = connect(state => {
    const {player, player_game_session, player_game_session_activity, result, skill, user} = state;

    return {
        players: player.players,
        owned_players: player.owned_players,
        retrieved_assigned_players: player.retrieved_assigned_players,
        retrieved_players: player.retrieved_players,
        assigned_players: player.assigned_players,
        skills: skill.skills,
        results: result.results,
        token: user.token,
        currentUser: user,
        currentUserId: user.currentUserId,
        currentUserFirstName: user.currentUserFirstName,
        playerGameSessions: player_game_session.player_game_sessions,
        playerGameSessionActivities: player_game_session_activity.player_game_session_activities
    };
});

export default withRouter(withState(PlayScreen));


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/play-screen.js